// @core/api/endpoints/notifications/list_notifications_by_user.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNotificationsResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List notifications for user
 * Retrieves all notifications for a specific user. Can filter by read/unread status and supports pagination for large notification lists.
 */
export async function ListNotificationsByUser(
  user_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNotificationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/notifications`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<ListNotificationsResponse>(requestPath, { ...requestOptions, params });
}
